/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_PositionInputs */

const en_update_position = /** @type {(inputs: Update_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Position`)
};

const fr_update_position = /** @type {(inputs: Update_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour la position`)
};

const de_update_position = /** @type {(inputs: Update_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position aktualisieren`)
};

const it_update_position = /** @type {(inputs: Update_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna posizione`)
};

const ru_update_position = /** @type {(inputs: Update_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить позицию`)
};

const es_update_position = /** @type {(inputs: Update_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar posición`)
};

const zh_cn2_update_position = /** @type {(inputs: Update_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新位置`)
};

const ja_update_position = /** @type {(inputs: Update_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置を更新`)
};

const hi_update_position = /** @type {(inputs: Update_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति अपडेट करें`)
};

const pt_pt2_update_position = /** @type {(inputs: Update_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar posição`)
};

/**
* | output |
* | --- |
* | "Update Position" |
*
* @param {Update_PositionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_position = /** @type {((inputs?: Update_PositionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_PositionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_update_position(inputs)
	if (locale === "de") return de_update_position(inputs)
	if (locale === "it") return it_update_position(inputs)
	if (locale === "ru") return ru_update_position(inputs)
	if (locale === "es") return es_update_position(inputs)
	if (locale === "zh-CN") return zh_cn2_update_position(inputs)
	if (locale === "ja") return ja_update_position(inputs)
	if (locale === "hi") return hi_update_position(inputs)
	if (locale === "pt-PT") return pt_pt2_update_position(inputs)
	return en_update_position(inputs)
});